import { Classes, Divider } from "@blueprintjs/core";
import { PlanrPopover } from "modules/common/components/planr/popover/Popover";
import { observer } from "mobx-react";
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon";
import { ChangelogType } from "modules/root/models/changelog";
import React from "react";
import styles from "./AppVersion.module.scss";

/** Версия для показа приходит с сервера; старый сервер её не отдаёт — тогда номер сборки как есть */
export const displayVersion = (log: ChangelogType) => log.display || log.name;

export const AppVersion = observer(({ version, display, changelog }: AppVersionProps) => {
    const last = changelog.length - 1;
    const current = display || version;
    return changelog.length ? (
        <PlanrPopover
            enforceFocus={false}
            isOpen={undefined}
            className="app-version"
            content={
                <div className={`${styles.changelog} ${Classes.ELEVATION_2}`}>
                    {changelog.map((log, index) => (
                        <div key={log.name}>
                            <h3 className={styles.title}>{displayVersion(log)}</h3>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: log.description,
                                }}
                            />
                            {index < last && <Divider />}
                        </div>
                    ))}
                </div>
            }
        >
            {renderVersion(current, true)}
        </PlanrPopover>
    ) : (
        renderVersion(current, false)
    );
});

const renderVersion = (version: string, interactive: boolean) =>
    interactive ? (
        <button type="button" className={styles.version} title="Список изменений">
            <span>v{version}</span>
            <GeneralIcon type="general-chevron-down" size={12} className={styles.chevron} />
        </button>
    ) : (
        <span className={styles.versionStatic}>v{version}</span>
    );

interface AppVersionProps {
    /** Номер сборки, 26.10.28 */
    version: string;
    /** Версия для показа: «2.0», «2.26.11.3» */
    display: string;
    changelog: ChangelogType[];
}
